 import { useState } from 'react';
import { toast } from 'react-toastify'
import { fetchGroups } from '../../../../../../services/groups';

const useGroups = () => {
    const [groups, setGroups] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const getGroups = async (filter) => {
        try {
          if (filter.includes('null')) return;
          setIsLoading(true)
          const response = await fetchGroups(filter)
          const allGroups = response?.data?.resources
          if (allGroups.length === 0) {
            toast.error('No matching records found, please modify your search and try again')
          }
          setGroups(allGroups)
          setIsLoading(false)
        } catch (error) {
          toast.error(error.message)
          setIsLoading(false)
        }
      }
    return { groups, areGroupsLoading: isLoading, getGroups, setGroups };
}

export default useGroups;
